module.exports = __webpack_public_path__ + "static/media/LogoPCS.3d7fddff.svg";